angular.module('zc.zenclerkS')
  .component('zcsDashboardWidgetRealtime', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetRealtimeController
  });

zcsDashboardWidgetRealtimeController.$inject = ['$filter', '$interval', '$scope', '$location', '$q', 'MongoConversion', 'MongoHistory', 'ZcsDeviceName'];
function zcsDashboardWidgetRealtimeController($filter, $interval, $scope, $location, $q, MongoConversion, MongoHistory, ZcsDeviceName) {
  const vm = this;
  const SHOW_DATA_MINUTES = 30;
  const WIDGET_WRAPPER_SELECTOR = '.realtime-wrapper';
  const GRAY_OVERLAY_CLASSNAME = 'gray-overlay';
  const DATA_FETCH_INTERVAL_MS = 3000;
  const MINUTES_BEFORE_SLEEP_MODE = 5;
  const SECONDS_BEFORE_SLEEP_MODE = MINUTES_BEFORE_SLEEP_MODE * 60;
  const DEVICES = _.omit(ZcsDeviceName.getDeviceNames(), 'devicefree');
  let pageDataFetchingInterval;
  let pageDataIntervalStartingTime;
  let lastHistoryDate;

  vm.$onInit = () => {
    vm.isLoading = true;
    vm.showNoDataOverlay = false;
    vm.redrawPieChart = false;
    // if away from keyboard for a while, turn on pause mode to save bandwidth &
    // avoid crashing tab on background.
    vm.isPaused = false;
    vm.showDataMinutes = SHOW_DATA_MINUTES;
    vm.continueRealtime = continueRealtime;
    vm.conversions = [];
    vm.histories = [];
    vm.minutesBeforeSleepMode = MINUTES_BEFORE_SLEEP_MODE;
    vm.project = vm.dashboard.project;

    startFetchingPageData();

    $scope.$on('$destroy', () => {
      $interval.cancel(pageDataFetchingInterval);
      clearNoDataStatus();
    });
  };

  function startFetchingPageData() {
    lastHistoryDate = getDatetimeFromMinutesAgo(SHOW_DATA_MINUTES);

    const conversionsPromise = getConversions(lastHistoryDate);
    const getHistoriesPromise = getHistories(lastHistoryDate);

    $q.all([
      conversionsPromise,
      getHistoriesPromise,
    ]).then(([conversions, histories]) => {
      vm.conversions = conversions;
      vm.histories = histories;

      if(histories && histories.length <= 0) {
        applyNoDataStatus();
      } else {
        disableGrayOverlay();
        generateData();
      }

      initializePageDataFetchingInterval();
    });
  }

  function stopFetchingPageData() {
    vm.showNoDataOverlay = false;
    vm.isPaused = true;
    enableGrayOverlay();
    $interval.cancel(pageDataFetchingInterval);
  }

  function initializePageDataFetchingInterval() {
    if(pageDataFetchingInterval) {
      return;
    }

    pageDataIntervalStartingTime = new Date();
    pageDataFetchingInterval = $interval(() => {
      // Check if we should turn this off and pause
      const runningTimeInSeconds = moment.tz(vm.project.region).diff(moment.tz(pageDataIntervalStartingTime, vm.project.region), 'seconds');
      if(runningTimeInSeconds > SECONDS_BEFORE_SLEEP_MODE) {
        stopFetchingPageData();
        return;
      }

      fetchAndUpdatePageData();
    }, DATA_FETCH_INTERVAL_MS);
  }


  function fetchAndUpdatePageData() {
    const conversionsPromise = getConversions(lastHistoryDate);
    const getHistoriesPromise = getHistories(lastHistoryDate);

    $q.all([
      conversionsPromise,
      getHistoriesPromise,
    ]).then(([conversions, histories]) => {
      // In case we are showing the overlay and there will be visit,
      // we can remove the overlay
      const gotNewHistories = histories && histories.length > 0;
      if(vm.showNoDataOverlay && gotNewHistories) {
        clearNoDataStatus();
      }

      vm.conversions = conversions;
      vm.histories = vm.histories.concat(histories);
      vm.histories = _.uniqBy(vm.histories, '_id');
      vm.histories = _.filter(vm.histories, d => {
        //SHOW_DATA_MINUTES + 1 would display empty bar chart after 1 minute, so
        //SHOW_DATA_MINUTES only makes the chart go into no data mode as soon as the last
        //visible bar has been destroyed
        const maxDatetime = moment.tz(getDatetimeFromMinutesAgo(SHOW_DATA_MINUTES), vm.project.region).startOf('minute');
        const isTooOldToBeShown = moment.tz(d.opened_at, vm.project.region).isAfter(maxDatetime);
        return isTooOldToBeShown;
      });

      generateData();

      // Apply No Data Status when there are no histories
      // left after filtering them above
      if(vm.histories.length <= 0) {
        applyNoDataStatus();
      }
    });

    vm.isLoading = false;
  }

  function getDatetimeFromMinutesAgo(minutes = SHOW_DATA_MINUTES) {
    return moment.tz(vm.project.region).subtract(minutes, 'minutes').valueOf();
  }

  function reDrawPieChart() {
    // this variable is binded with the pie chart,
    // and it will redraw the pie chart when there's
    // a change
    vm.redrawPieChart = true;
  }

  function updateLastHistoryDate() {
    lastHistoryDate = _.max(_.map(vm.histories, 'opened_at'));

    // Don't use the value above if it's
    // invalid or from dummy data, instead
    // define the last history date as NOW minus SHOW_DATA_MINUTES
    if(!_.isFinite(lastHistoryDate) || vm.showNoDataOverlay) {
      lastHistoryDate = getDatetimeFromMinutesAgo(SHOW_DATA_MINUTES);
    }
  }

  function continueRealtime() {
    vm.isPaused = false;
    pageDataFetchingInterval = null;
    // display loading here?
    // vm.isLoading = true;
    startFetchingPageData();
  }

  function enableGrayOverlay() {
    angular.element(WIDGET_WRAPPER_SELECTOR).addClass(GRAY_OVERLAY_CLASSNAME);
  }

  function disableGrayOverlay() {
    angular.element(WIDGET_WRAPPER_SELECTOR).removeClass(GRAY_OVERLAY_CLASSNAME);
  }

  function applyNoDataStatus() {
    if(vm.showNoDataOverlay) {
      return;
    }

    vm.showNoDataOverlay = true;
    vm.histories = generateDummyHistoryData();
    // generate data here so that
    // the no data layout gets applied immediately,
    // not after DATA_FETCH_INTERVAL_MS
    generateData();

    enableGrayOverlay();
  }

  function clearNoDataStatus() {
    vm.showNoDataOverlay = false;

    // we should also clear histories, because there is dummy histories now...
    vm.histories = [];

    // and as we clear the histories, we should display the loading spinner
    // while fetching real histories!
    vm.isLoading = true;

    disableGrayOverlay();
  }

  function generateDummyHistoryData() {
    const currentTime = moment.tz(vm.project.region).valueOf();

    let startingTime = moment.tz(vm.project.region).subtract(SHOW_DATA_MINUTES, 'minutes').valueOf();
    let dummyHistoryData = [];

    while(startingTime < currentTime) {
      // add random amount of history data
      const randomDevice = _.sample(_.keys(DEVICES));
      _.each(_.range(_.random(30)), () => {
        let randomId = _.random(0.1);
        const historyData = {
          _id: randomId,
          _usid: randomId,
          opened_at: moment.tz(startingTime, vm.project.region).add(3, 'seconds').toDate(),
          device: randomDevice,
        };
        dummyHistoryData.push(historyData);
      });

      // swift the starting time X minutes further
      startingTime = moment.tz(startingTime, vm.project.region).add(_.random(1.3), 'minute').valueOf();
    }

    return dummyHistoryData;
  }


  function getConversions(startTime = moment.tz(vm.project.region).valueOf(), endTime = moment.tz(vm.project.region).valueOf()) {
    const apiKey = vm.dashboard.project.apikey;
    return MongoConversion.find({
      apikey: apiKey,
      created_at: {
        $gte: startTime,
        $lt: endTime,
      },
    }, {
      fields: [
        'created_at',
      ],
    });
  }

  function getHistories(startTime = moment.tz(vm.project.region).valueOf(), endTime = moment.tz(vm.project.region).valueOf()) {
    const apiKey = vm.dashboard.project.apikey;
    return MongoHistory.find({
      apikey: apiKey,
      opened_at: {
        $gt: startTime,
        $lt: endTime,
      },
    }, {
      limit: 5000,
      // take only what's necessary
      fields: [
        '_id',
        '_usid',
        'device',
        'opened_at',
      ],
    });
  }

  function generateData() {
    const oldHistoryCount = vm.historyCount;
    vm.historyCount = vm.histories.length;
    vm.sessionCount = _.uniqBy(vm.histories, h => h._usid).length;
    vm.conversionCount = vm.conversions.length;

    updateLastHistoryDate();

    calculateDeviceChartData();

    generateHistoryBuckets();

    // redraw pie chart on data changes
    if(oldHistoryCount !== vm.historyCount) {
      reDrawPieChart();
    }

    // stop loading here if we got data to show,
    // otherwise stop at the end of fetchAndUpdatePageData()
    if(vm.historyCount > 0) {
      vm.isLoading = false;
    }
  }

  /**
   * Takes history list and converts it into visualizable format
   *
   * {
   *   start:
   *   end:
   *   historyCount:
   *   sessionCount:
   *   perDeviceCounts:
   *   conversionCount:
   * }
   */
  function generateHistoryBuckets() {
    const buckets = _.range(-60, 60 * SHOW_DATA_MINUTES + 60, 60);
    const defaultDeviceCountValues = _.transform(DEVICES, (result, deviceName, deviceType) => {
      result[deviceType] = 0;
    });

    vm.historiesByBucket = [];
    _.each(buckets, (bucket, i) => {
      // don't handle the last bucket
      if(_.isUndefined(buckets[i + 1])) return;

      const startTime = moment.tz(vm.project.region).subtract(buckets[i + 1], 'seconds').startOf('minute').valueOf();
      const endTime = moment.tz(vm.project.region).subtract(bucket, 'seconds').startOf('minute').valueOf();
      const perDeviceCounts = defaultDeviceCountValues;
      const conversionCount = _.chain(vm.conversions)
        .filter(c => {
          const valueOfCreatedAt = $filter('changeDatetimeFrom')('localToRegion', c.created_at, 'integer', vm.project.region);
          return valueOfCreatedAt >= startTime && valueOfCreatedAt < endTime;
        })
        .size()
        .value();
      const historiesForBucket = _.chain(vm.histories)
        .filter(h => {
          const valueOfOpenendAt = $filter('changeDatetimeFrom')('localToRegion', h.opened_at, 'integer', vm.project.region);
          return valueOfOpenendAt >= startTime && valueOfOpenendAt < endTime;
        })
        .each(h => {
          perDeviceCounts[h.device] += 1;
        })
        .value();

      const sessionCount = _.uniqBy(historiesForBucket, d => d._usid).length;
      const currentBucketData = {
        start: startTime,
        end: endTime,
        perDeviceCounts: perDeviceCounts,
        conversionCount: conversionCount,
        sessionCount: sessionCount,
        historyCount: historiesForBucket.length,
      };

      vm.historiesByBucket.push(currentBucketData);
    });

    vm.historiesByBucket = _.sortBy(vm.historiesByBucket, d => -d.start);
  }

  function calculateDeviceChartData() {
    const baseDeviceChartData = _.map(DEVICES, (deviceName, deviceType) => {
      return {
        label: deviceName,
        type: deviceType,
      };
    });

    let deviceChartData = _.chain(vm.histories)
      .groupBy(h => h.device)
      .map((deviceHistories, device) => {
        const data = {};
        data[device] = deviceHistories.length / vm.histories.length * 100;
        return data;
      })
      .value();

    // assign an object array into one object
    deviceChartData = _.assign.apply(_, deviceChartData);

    // loop the base chart data and apply device values from deviceChartData
    vm.chartDataDevices = _.map(baseDeviceChartData, device => {
      const deviceValue = _.get(deviceChartData, device.type, 0);
      return {
        label: device.label,
        value: deviceValue,
      };
    });
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.component.js